module.exports = __webpack_public_path__ + "frontend/img/icon-user-group.a18ae189.svg";